import * as types from './mutations-types'
import auth from '../services/auth'

export const attemptLogin = (context, payload) => {
  return auth.login(payload.email, payload.password, payload.channel)
    .then((data) => {
      // TMP
      if (data.user.comitente) {
        window.location = '/#/logout'
        return Promise.reject('Comitente não tem acesso')
      }
      context.commit(types.setToken, data.token)
      context.commit(types.setUser, data.user)
      return Promise.resolve(data)
    })
    .catch((res) => {
      return Promise.reject(res)
    })
}

export const clearUserAndToken = (context) => {
  // return new Promise((resolve, reject) => {
  context.commit(types.setToken, {})
  context.commit(types.setUser, {})
  return Promise.resolve()
  // resolve()
  // })
}



// WEBPACK FOOTER //
// ./src/domain/auth/store/actions.js